import React, { useState, useEffect } from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/ArticleNewsCover.png'
import {
    Footer
} from '../../components/footer/components'
import { 
    ArticleWrapper,
 } from './style'
import { 
    NewsCardComponent,
 } from '../../components/newscard/component';
import { getAllArticles } from '../../api';
import { useTranslation } from 'react-i18next';

export const Article = () => {
    const { t } = useTranslation('common');

    const [articles, setArticles] = useState([]);
    useEffect(async () => {
        const data = await getAllArticles();
        setArticles(data.data.data.data);
    }, []);

    return (
        <>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption={t('article.heroCaption') || 'LEGAL CLARITY STRATEGIC INSIGHT'}
                addFullGrey={false}
            />
            <ArticleWrapper>
                {articles.slice().reverse().map((row) => (
                    <NewsCardComponent 
                        title={row.title}
                        description={row.body}
                        created_at={row.created_at}
                        bg={row.thumbnail_path}
                        path={"article/" + row.id}
                    />
                ))}
            </ArticleWrapper>
            
            <Footer />
        </>
    )
}